export const MAX_PEERS = 5;
